import { render, staticRenderFns } from "./BuyingPriceCents.vue?vue&type=template&id=54855387&scoped=true&"
import script from "./BuyingPriceCents.vue?vue&type=script&lang=js&"
export * from "./BuyingPriceCents.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54855387",
  null
  
)

export default component.exports